
// Class Definition
var TextCountComponent = function() {
    var initCount = function() {

        var contaEMostra = function (string) {
            
            var charCount = 0, wordCount = 0, linesCount = 0;
            if (string) {
                charCount   = string.length;
                var palavras = string.replace(/(\r\n|\n|\r|\t)/g, " ").split(/\s+/);
                wordCount = palavras.reduce(function(sum, item){
                    sum += item.length>0?1:0;
                    return sum;
                }, 0);
                linesCount  = string.split(/\r*\n/).length;
            }
            var spacesCount  = string.replace(/\t/g, " ").split(" ").length - 1;
            var numbersCount = string.match(/\d/g) ? string.match(/\d/g).length : 0;
            var charCountWithoutSpaces = (charCount > spacesCount ? (charCount - spacesCount - linesCount + 1) : 0);
            var vowelsCount  = 0;
            for (var count = 0; count < string.length; count++) {
                var char = string.charAt(count);
                if (char.match(/[aeiouAEIOUáàãâéêíóôõúüÁÀÃÂÉÊÍÓÔÕÚÜ]/)) {
                    vowelsCount ++;
                }
            }

            $('.r1 span').html(charCount);
            $('.r2 span').html(charCountWithoutSpaces);
            $('.r3 span').html(wordCount);
            $('.r4 span').html(spacesCount);
            $('.r5 span').html(linesCount);
            $('.r6 span').html(vowelsCount);
            $('.r7 span').html(numbersCount);
        };

        var textBox = $("#textCount");
        textBox.on("change paste keyup", function () {
            contaEMostra(textBox.val());
        });
        contaEMostra(textBox.val());
         

    }

    return {
        init: function() {
            initCount();
        }
    };
}();

// Class Initialization
$(function(){
    TextCountComponent.init();
    
    
});